/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachines/Services/VirtualMachineResourceServices" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";

import {
    PackageMetadata,
} from "DistributedTask/Client/Contracts/TaskAgent";

export interface IVirtualMachineResourceService extends IVssService {
    getTargetPackages(): Promise<PackageMetadata[]>;
}

class VirtualMachineResourceServices extends VssService implements IVirtualMachineResourceService {

    public getTargetPackages(): Promise<PackageMetadata[]> {
        return this._getTaskAgentClient().getPackages("agent", undefined, 1);
    }

    private _getTaskAgentClient(): ITaskAgentRestClient {
        return getTaskAgentClient(this.pageContext);
    }
}

Services.add("IVirtualMachineResourceService", { serviceFactory: VirtualMachineResourceServices });